import { authHeader } from '../_helpers';
import { apiConstants } from '../_constants'
import Cookies from 'universal-cookie';
import request from 'superagent';
import { alertActions, userActions , loadingActions } from '../_actions';
import { store } from '../_helpers/store';
import { history , utils } from '../_helpers';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export const transactionService = {
    createMemberDeposit , getMemberDepositList , getMemberWithdrawalList , getMemberOrdersList
     , createMemberWithdrawal , createListingForBuyPostTrade , createListingForSellPostTrade 
     , getExchangepageData , createMemberBuyOrder , createMemberSellOrder , getCompanySettings , getMemberTransactionList , 
     createMemberHWGCashDeposit  , createMemberHWGCashRedemption , getMemberHWGCashTransactionList ,getMemberHWGCashRedeemTransactionList 
}

function getMemberDepositList(page , pagesize , memberId){
    
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetMemberDepositList` , formBody )
        .then(response=> response)
    )
}


function getMemberWithdrawalList(page , pagesize , memberId){
    
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetMemberWithdrawList` , formBody )
        .then(response=> response)
    )
}

function getMemberHWGCashTransactionList(page , pagesize , memberId){
    
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetHWGCashTransactionList` , formBody )
        .then(response=> response)
    )
}

function getMemberHWGCashRedeemTransactionList(page , pagesize , memberId){
    
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetHWGCashRedeemTransactionList` , formBody )
        .then(response=> response)
    )
}

function getMemberOrdersList(page , pagesize , memberId){
    
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetMemberOrdersList` , formBody )
        .then(response=> response)
    )
}

function getMemberTransactionList(page , pagesize , memberId){
    var formBody = {
        "page" : page , 
        "pagesize" : pagesize , 
        "memberId" : memberId
    }

    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/GetMemberTransactionList` , formBody )
        .then(response=> response)
    )
}

function getExchangepageData(memberId){
    
    return (
        utils.Get(`${apiConstants.ENDPOINT}tx/GetExchangepageData/${memberId}`  )
        .then(response=> response)
    )
}

function createMemberDeposit(formBody , file) {
    store.dispatch(showLoading());

    let token ;
    let authentication = store.getState().authentication;
    token = authentication ? authentication.user.token : '' ;

    let postrequest = request
        .post(`${apiConstants.ENDPOINT}tx/MemberDeposit`)
        .set('Authorization' , `Bearer ${token}`);


    utils.toFormFields(formBody).forEach(
        ([field, value]) => value ? postrequest.field(field, value) : null
    );

    if(file){
        postrequest
        .attach('file', file, file.name)
    }

    return (
        postrequest
            .then(response=>{

                store.dispatch(
                    alertActions.success("Deposit request successful")
                );

                window.location.reload();
            })
            .catch( error => {
                store.dispatch(hideLoading());
                store.dispatch(alertActions.error(error.response));

                window.location.reload();
            } )
    )
 }

 function createMemberWithdrawal (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/MemberWithdraw` , formBody)
            .then(response=>{

                store.dispatch(
                    alertActions.success("Withdraw request order successful")
                );

                window.location.reload();
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )
 }
 
 function createMemberHWGCashDeposit (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/MemberHWGCashDeposit` , formBody)
            .then(response=>{

                store.dispatch(
                    alertActions.success("HWG Cash request order successful")
                );

                window.location.reload();
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )
 }

 function createMemberHWGCashRedemption (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/MemberHWGCashRedemption` , formBody)
            .then(response=>{

                store.dispatch(
                    alertActions.success("HWG Cash redemption order successful")
                );

                window.location.reload();
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )
 }
 
 function createListingForBuyPostTrade (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/CreateListingForBuyPostTrade` , formBody)
            .then(response=>{

                store.dispatch(
                    alertActions.success("Post Trade created successfully")
                );

                window.location.href = "/account/exchange";
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )
 }

 function createListingForSellPostTrade (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/CreateListingForSellPostTrade` , formBody)
            .then(response=>{

                store.dispatch(
                    alertActions.success("Post Trade created successfully")
                );

                window.location.href = "/account/exchange";
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )
 }

 function createMemberBuyOrder (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/MemberBuyPostTrade` , formBody)
            .then(response=>{
                
                store.dispatch(
                    alertActions.success("Buy order created successfully")
                );

                window.location.href = "/account/orders";
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )

 }

 function createMemberSellOrder (formBody){
     
    return (
        utils.Post(`${apiConstants.ENDPOINT}tx/MemberSellPostTrade` , formBody)
            .then(response=>{
                
                store.dispatch(
                    alertActions.success("Sell order created successfully")
                );

                window.location.href = "/account/orders";
            })
            .catch(()=>{
                
                window.location.reload();
            })
    )

 }

 function getCompanySettings (){
     
    return (
        utils.Get(`${apiConstants.ENDPOINT}setting/GetSettings`  )
        .then(response=> response)
    )
 }
 


// WEBPACK FOOTER //
// ./src/_services/transaction.service.js